import httpService from '@/modules/common/services/httpService';
import gatewayService from '@/modules/common/services/gatewayService';

const baseRoute = '/business/accounts/v1';

const fetchBranding = async () => httpService.get(`${baseRoute}/branding`)
  .then((res) => res.data?.data.branding);

const fetchAttributes = async () => httpService.get(`${baseRoute}/attributes`)
  .then((res) => res.data?.data.attributes);

const fetchFeaturesFlags = async (businessUid) => httpService.get(`platform/v1/businesses/${businessUid}/features`)
  .then((res) => res.data?.data);

const fetchBusiness = async (businessUid) => httpService.get(`platform/v1/businesses/${businessUid}`)
  .then((res) => res.data?.data);

const fetchBusinessProfile = async () => httpService.get('v2/profile/business')
  .then((res) => res.data);

// Backend may return { data: { uid, branding, ... } } or the object at top level; unwrap so callers get { branding, ... }
const fetchBusinessSettings = async (businessUid) => httpService.get(`v2/settings/businesses/${businessUid}`)
  .then((res) => res.data?.data ?? res.data);

const updateBusinessSettings = async (businessUid, payload) => httpService.put(`v2/settings/businesses/${businessUid}`, payload)
  .then((res) => res.data);

const fetchSmsBalance = async (businessUid) => httpService.get(`platform/v1/businesses/${businessUid}/sms_balance`)
  .then((res) => res.data);

const fetchSmsQuotas = async (businessUid) => httpService.get(`platform/v1/businesses/${businessUid}/sms_quotas`)
  .then((res) => res.data);

const updateSmsAutoReload = async (businessUid, enabled) => httpService.put(`platform/v1/businesses/${businessUid}/sms_auto_reload`, { auto_reload: enabled })
  .then((res) => res.data);

// The business's online profile, which holds its client languages (`supported_languages`), or
// null when it has none yet.
const fetchOnlineProfile = async () => gatewayService.get('v3/business_administration/online_profiles')
  .then((res) => res.data?.data?.online_profiles?.[0] || null)
  .catch((error) => {
    if (error?.response?.status === 404) return null;
    throw error;
  });

export default {
  fetchBranding,
  fetchAttributes,
  fetchFeaturesFlags,
  fetchBusiness,
  fetchBusinessProfile,
  fetchBusinessSettings,
  updateBusinessSettings,
  fetchSmsBalance,
  fetchSmsQuotas,
  updateSmsAutoReload,
  fetchOnlineProfile,
};
